import { Type, type Static } from "@sinclair/typebox";

const TimestampSchema = Type.String({ format: "date-time" });
const NullableTimestampSchema = Type.Union([TimestampSchema, Type.Null()]);

export const ExternalAccountSystemSchema = Type.Union([
  Type.Literal("opencloud"),
  Type.Literal("matrix")
]);
export type ExternalAccountSystem = Static<typeof ExternalAccountSystemSchema>;

export const ExternalAccountStatusSchema = Type.Union([
  Type.Literal("not_provisioned"),
  Type.Literal("pending"),
  Type.Literal("provisioning"),
  Type.Literal("active"),
  Type.Literal("suspending"),
  Type.Literal("suspended"),
  Type.Literal("failed")
]);
export type ExternalAccountStatus = Static<typeof ExternalAccountStatusSchema>;

export const ExternalAccountOperationSchema = Type.Union([
  Type.Literal("provision"),
  Type.Literal("suspend"),
  Type.Literal("restore"),
  Type.Literal("verify")
]);
export type ExternalAccountOperation = Static<typeof ExternalAccountOperationSchema>;

export const ExternalAccountBindingSchema = Type.Object(
  {
    system: ExternalAccountSystemSchema,
    externalUserId: Type.Union([Type.String({ minLength: 1, maxLength: 1024 }), Type.Null()]),
    status: ExternalAccountStatusSchema,
    lastOperation: Type.Union([ExternalAccountOperationSchema, Type.Null()]),
    lastVerifiedAt: NullableTimestampSchema,
    lastErrorCode: Type.Union([Type.String({ minLength: 1, maxLength: 128 }), Type.Null()]),
    lastErrorMessage: Type.Union([Type.String({ minLength: 1, maxLength: 2048 }), Type.Null()]),
    createdAt: NullableTimestampSchema,
    updatedAt: NullableTimestampSchema
  },
  { additionalProperties: false }
);
export type ExternalAccountBinding = Static<typeof ExternalAccountBindingSchema>;
